import { ConfigService }              from '..';

/**
 * The service that implements the functions related to the injection of the chatbot agent 
 * giving possible configurations in standard mode or integrated mode.
 */
export class BotInjectorService {

    /**
     * Gets the injection element giving botSettings configuration.
     */
    public static getInjectionTagId(): string | undefined {
        const injectionElemId: string = ConfigService.getIntegrationTagId();
        if (!document.getElementById(injectionElemId) && (!window.botSettings || !window.botSettings.htmlElemIdForIntegration)) {
            BotInjectorService.createInjectionElement(injectionElemId);
        }
        return injectionElemId;
    }

    /**
     * Creates and append div html element with ID 'synapse-chatbot" to display Chatbox Widget.
     */
    public static createInjectionElement(tagId: string) {
        const injectionElem: HTMLElement = document.createElement('div');
        injectionElem.setAttribute('id', tagId);
        document.getElementsByTagName('body')[0].appendChild(injectionElem);
    }
}
